import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { ILogRequest, ILogsApiData } from './logger.model';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private endpoint = "custom-log";

  constructor(private apiService: ApiService) { }

  getAllLogs(request: ILogRequest) {
    let params = new HttpParams({
      fromObject: {
        pageNumber: request.pageNumber,
        pageSize: request.pageSize,
        ...(request.type && { level: request.type.toLowerCase() }),
        ...(request.search && { search: request.search }),
        ...(request.startDate && { startDate: request.startDate }),
        ...(request.endDate && { endDate: request.endDate }),
        ...(request.sort && { sortBy: request.sort }),
        ...(request.sortOrder && { sortOrder: request.sortOrder }),
      },
    });

    return this.apiService.get<ILogsApiData>({
      Url: `${this.endpoint}/all`,
      Params: params
    });
  }

  deleteLogs(ids: string[]) {
    return this.apiService.delete({
      Url: `${this.endpoint}/delete`,
      Body: ids
    });
  }
}
